export default "__VITE_ASSET__DVHxYW9p__"